const RightContent = () => {
  return (
    <div
      className="right-content"
      style={{
        width: "50%",
        height: "100%",
        position: "relative",
      }}
    >
      <img
        src="/studying.png"
        alt="Student studying"
        width="100%"
        height="100%"
      />
      <div>
        <p>
          Create custom flashcard decks to memorize key facts and build flexible
          exams to prove what you know. It is a simple, powerful way to manage
          your learning and master any subject for free.
        </p>
      </div>
    </div>
  );
};

export default RightContent;
